import { Component } from "@angular/core";
import { MenuController } from "@ionic/angular";
import { Platform } from "@ionic/angular/standalone";
import { Router } from "@angular/router";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { BaseHelper } from "./baseHelper";
import { Pages } from "./interfaces/pages";
import { GlobalProvider } from "src/services/global";
import { UserAPIService } from "src/services/user_api.service";
import { AuthService } from "src/services/auth.service";
import { MenuHelper } from "./menuHelper";
import { PublicService } from "src/services/public.service";
import { environment } from "src/environments/environment";
import { Title } from "@angular/platform-browser";

// import { NotificationSocket } from 'src/services/notification_socket.service';

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: [
    "app.component.scss",
    "./style/side-menu.scss",
    "./style/side-menu.responsive.scss",
  ],
})
export class AppComponent {
  textDir;
  environment = environment;
  // public generalPages: Array<Pages>;
  constructor(
    public platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public b: BaseHelper,
    private userAPI: UserAPIService,
    private authAPI: AuthService,
    private pubApi: PublicService,
    public g: GlobalProvider,
    public m: MenuHelper,
    private router: Router,
    private titleService: Title,
    private menu: MenuController
  ) {
    this.initializeApp();
  }

  initializeApp() {
    const defaultRoot = "/login";
    const defaultAdminRoot = "/login/admin";
    this.platform.ready().then(async () => {
      this.statusBar.styleDefault();
      // this.b.menuClose();
      this.b.menuOpen();

      this.splashScreen.hide();
      const setting: any = await (await this.pubApi.globalSetting())
        .toPromise()
        .catch((err) => {
          return Promise.resolve(null);
        });

      if (setting) {
        this.g.globalSettingDetail = setting.detail;
        this.titleService.setTitle(setting.detail.platformName);
        this.g.mediaUrl = setting.mediaUrl;
      }

      const urlParams = new URLSearchParams(window.location.search);
      const sso = urlParams.get("sso");
      const resetToken = urlParams.get("resetToken");
      if (resetToken) {
      } else {
        if (sso) {
        } else {
          console.log(`this.router.url?`, this.router.url);
          // if (`/login` === this.router.url || `/` === this.router.url) {
          //   console.log(`enter login`);
          //   this.g.loadingJwt = false;
          //   // this.b.navigateRoot(`/customer`);
          //   return;
          // } else if (`/login/admin` === this.router.url) {
          //   this.g.loadingJwt = false;
          //   // this.b.navigateRoot(`/customer`);
          //   return;
          // }
          const tokenObj = await this.b.getJws();
          if (tokenObj && tokenObj.token) {
            console.log(`tokenObj?`, tokenObj);
            const { profileType } = tokenObj;
            const result = await (
              await this.authAPI.loginViaToken(tokenObj.token)
            )
              .toPromise()
              .catch((err) => {
                return Promise.resolve(null);
              });

            if (!result) {
              this.g.loadingJwt = false;
              this.b.clearJws();
              // return this.b.navigateRoot(defaultRoot);
            }
            const r: any = result;
            console.log(`wht is r?`, r);
            this.b.setJws(tokenObj, r.profile);
            this.b.loadLoading(false);
            this.m.loadAdminMap();
            this.b.menuOpen();
            this.b.menuOpen();
            console.log(`this.router.url (2)`, this.router.url);
            //
            this.g.loadingJwt = false;
            // if (`/login` === this.router.url) {
            //   console.log(`enter login`);
            //   this.g.loadingJwt = false;
            //   this.b.navigateRoot(`/customer`);
            //   return;
            // } else if (`/login/admin` === this.router.url) {
            //   this.g.loadingJwt = false;
            //   this.b.navigateRoot(`/customer`);
            //   return;
            // }
          } else {
            console.log(`this.router.url huh?`, this.router.url);
            this.g.loadingJwt = false;
            this.b.clearJws();
            // this.b.navigateRoot(defaultRoot);
          }
        }
      }
    });
  }

  toggleMenu(url?) {
    this.menu.toggle();
  }
  async generateSSO() {
    // (await this.userAPI.generateSSO()).subscribe((result) => {
    //   const r: any = result;
    //   if (!r.ok) return;
    //   this.b.toast(r.detail.ssoToken, 10000);
    // });
  }
  async showBearer() {
    this.b.toast(this.g.jws, 10000);
  }

  goToWebsite() {
    this.b.openTab(`https://qzonetech.com`);
  }
  logout() {
    // this.ns.disconnect();
    this.b.clearJws();
    this.b.navigateRoot(`/login`);
  }
  profile() {
    this.b.navigateRoot(`/profile`);
  }
}
